<h2 mat-dialog-title>{{data.title || 'Conferma'}}</h2>

<mat-dialog-content>
    <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button *ngIf="data.title !== 'Attenzione' " (click)="onCancel()">Annulla</button>
    <button mat-flat-button color="primary" (click)="onConfirm()">{{data.title === 'Attenzione' ? 'Ok' : 'Conferma'}}</button>
</mat-dialog-actions>